module.exports = __webpack_public_path__ + "static/media/golfer-1-a.d4540fc2.png";